import type { IProductEntity } from "~/entities";
import { ProductMM } from "~/entities/product/business/ProductMM";
import { LastSeenProductsStore } from "./LastSeenProductsStore";
import { computed } from "vue";

export function useLastSeenProductsStore() {
  const lastSeenProducts = computed(() => {
    return LastSeenProductsStore.lastSeenProducts.value.map((i) => new ProductMM(i));
  });

  function addProduct(product: IProductEntity) {
    LastSeenProductsStore.addProduct(product);
  }

  return {
    lastSeenProducts,
    addProduct,
  };
}